import React, { Component } from 'react';
import { connect } from 'react-redux';

import { bindActionCreators } from 'redux';
import * as actions from '../../actions/termometre.actions';

// eslint-disable-next-line
import style from './_style.css';

class Cooper extends Component {
    state = {
        value: undefined,
    };

    UNSAFE_componentWillMount() {
        this.read();
        this.id = setInterval(this.read, 20000);
    }

    componentWillUnmount() {
        if (this.id) {
            clearInterval(this.id);
            this.id = undefined;
        }
    }

    read = () => {
        this.props.getData(this.props.id).then((value) => {
            this.props.onChange(value);
            this.setState({ value: value });
        });
    };

    render() {
        const { value } = this.state;
        return (
            <div className={'barlow_semibold c_white center '}>
                {value && `${value} ºC`}
                {!value && `- ºC`}
            </div>
        );
    }
}
const mapStateToProps = (state) => {
    return {
        instance: state.instance,
        instance_changes: state.instance_changes,
        bluetooth: state.bluetooth,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions), dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Cooper);



// WEBPACK FOOTER //
// ./src/components/inputs/Cooper.js